import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Te niegan cada solicitud de crédito que haces y no sabes por qué.', 'Pagas tasas de interés altísimas y terminas dando el doble por lo mismo.', 'No calificas para comprar tu casa o tu carro, aunque tengas el ingreso.', 'Los bancos te cierran la puerta al capital que tu negocio necesita.', 'Intentaste disputar por tu cuenta y las cuentas negativas siguen ahí.', 'Nadie te ha explicado con claridad qué hay en tu reporte ni cómo arreglarlo.'];
export function Problem() {
  return <section className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-176" data-mp="1sprklui2onlu">
      <div className="max-w-5xl mx-auto" data-id="element-177" data-mp="1wqbl981uu9cq">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-178" data-mp="1wrcynj6cf7xm">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-179" data-mp="od6ospt7zokl">
            El Verdadero Problema
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-180" data-mp="9locb1zkkc5z">
            ¿Te suena{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-181" data-mp="5ldu8qyi5var">
              familiar?
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-182" data-mp="ejzmxexouqp9">
            Si te identificas con al menos dos de estas situaciones, tu reporte
            de crédito es lo que te está frenando.
          </p>
        </motion.div>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14" data-id="element-183" data-mp="3hzwwblo0zumj">
          {painPoints.map((point, index) => <motion.li key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.7,
          delay: index % 2 * 0.08,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex items-start gap-4 p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06]" data-id="element-184" data-mp="1qxfzf1ocsdbh" data-mpi={index}>
              <XCircle className="h-5 w-5 text-red-400/70 shrink-0 mt-0.5" strokeWidth={2} data-id="element-185" data-mp="1gzrzzyfsyhmz" />
              <span className="text-white/70 font-light leading-relaxed" data-id="element-186" data-mp="2octuqnsh3tq2">
                {point}
              </span>
            </motion.li>)}
        </ul>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center text-xl md:text-2xl text-white font-light leading-relaxed max-w-3xl mx-auto" data-id="element-187" data-mp="gqa7ob4xruia">
          No es tu culpa. El sistema de crédito no fue diseñado para que lo
          entiendas fácilmente.{' '}
          <span className="font-semibold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-188" data-mp="3l6l2vt3jasvz">
            Nosotros sí lo entendemos, y jugamos de tu lado.
          </span>
        </motion.p>
      </div>
    </section>;
}